import api from './config';

export const login = async (credentials) => {
  try {
    const response = await api.post('/users/login', credentials);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const register = async (token) => {
  try {
    const response = await api.post('/users/register', token);
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const verifyEmail = async (token) => {
  try {
    const response = await api.post('/users/verify-email', {token});
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
}

export const forgotPassword = async (email, language) => {
  try {
    const response = await api.post('/users/forgot-password', { email, language });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const resetPassword = async (token, newPassword) => {
  try {
    const response = await api.post('/users/reset-password', { token, newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
};

export const changePassword = async (currentPassword,newPassword ) => {
  try {
    const response = await api.post('/users/change-password', { currentPassword, newPassword });
    return response.data;
  } catch (error) {
    throw error.response?.data || { message: 'Network Error' };
  }
}
